import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react'
import { fetchCSRFToken, getCSRFCookie } from '@cfs-fixings/shared'

const prepareHeaders = async (headers: Headers) => {
  const xsrfCookie = getCSRFCookie() ?? await fetchCSRFToken(import.meta.env.VITE_API_BASE_URL)

  if (xsrfCookie) {
    headers.set('X-XSRF-TOKEN', decodeURIComponent(xsrfCookie[2]))
  }

  return headers
}

const rootQuery = fetchBaseQuery({
  baseUrl: import.meta.env.VITE_API_BASE_URL + '/api',
  credentials: 'include',
  headers: {
    'Accept': 'application/json',
  },
  prepareHeaders: prepareHeaders,
})

const baseQueryInterceptor: typeof rootQuery = async (args, api, extraOptions) => {
  // Execute HTTP request
  const result = await rootQuery(args, api, extraOptions)

  return result
}

export const emptySplitApi = createApi({
  baseQuery: baseQueryInterceptor,
  endpoints: () => ({ /* Using code gen */ }),
})
